import { graphql } from '../gql/gql.js'

export const LOGIN_MUTATION = graphql(`
  mutation Login($username: String!, $password: String!) {
    login(data: { username: $username, password: $password }) {
      user {
        id
        username
        email
        organisationId
        role
        scope
      }
      token
      shouldChangePassword
    }
  }
`)

export const USER_QUERY = graphql(`
  query User($userId: RoyID!) {
    user(where: { id: $userId }) {
      id
      username
    }
  }
`)
